/**
 * 利用規約・プライバシーポリシー関連の共通定数（課題88）。
 *
 * 新規ユーザー登録ポップアップ（UserRegistrationPopup）と口座登録時の同意ポップアップ
 * （TermsConsentPopup）の双方から参照し、バージョン・URL のハードコード二重管理を避ける。
 */

/** 利用規約のバージョン（改定時にインクリメント、Backend の DEFAULT_TERMS_VERSION と揃える） */
export const CURRENT_TERMS_VERSION = '1.0';

/** ワーカー向け利用規約（即給条項を内包）URL（Re:crew LP） */
export const WORKER_TERMS_URL = 'https://recrew-official.studio.site/terms-worker';

/** プライバシーポリシー URL（Re:crew LP） */
export const PRIVACY_POLICY_URL = 'https://recrew-official.studio.site/Privacypolicy';

/**
 * 即給（前払給与）利用規約のバージョン（改定時にインクリメント、Backend の
 * DEFAULT_SOKYU_TERMS_VERSION と揃える）。Re:crew 利用規約とは別文書として管理する。
 */
export const SOKYU_TERMS_VERSION = '1.0';

/**
 * 即給（前払給与）利用規約 URL。
 */
export const SOKYU_TERMS_URL = 'https://static.remittance.gmopg.jp/sokkyu/agreement/terms_of_company.html';
